module.exports = __webpack_public_path__ + "img/neteller_static.b71bc349.svg";